export default __webpack_public_path__ + "static/media/QuickPlayStage.27273873.png";